// Stored-XSS guard for every URL that reaches an href or a navigation call on the public site.
// Kept in its own dependency-free module so openExternal and the site components can import it
// without pulling in functions.js.

// Script-capable schemes. data: and file: are refused whole, not only data:text/html.
const SCRIPT_SCHEME = /^(javascript|vbscript|data|file):/;

// True when the browser would run the URL as script (or load it as a document) instead of
// navigating to a page. Normalised the way the URL parser does it: ASCII tab/CR/LF removed
// anywhere ("java\tscript:"), leading C0 controls and spaces trimmed ("\0 javascript:"),
// scheme compared case-insensitively. Non-strings are judged by the text React would render for
// them: ?x=javascript:alert(1)&x=y arrives from the router as an array and renders as its join.
export function isDangerousUrl(url) {
  if (url === null || url === undefined || url === '') return false;
  const s = String(url)
    .replace(/[\t\n\r]/g, '')
    // eslint-disable-next-line no-control-regex
    .replace(/^[\u0000-\u0020]+/, '');
  return SCRIPT_SCHEME.test(s.toLowerCase());
}

// The URL itself, or undefined when it carries a script-capable scheme — so href={sanitizeUrl(x)}
// renders an anchor without an href (href="" would reload the page).
export function sanitizeUrl(url) {
  return isDangerousUrl(url) ? undefined : url;
}

// Stricter than "not dangerous": an absolute http(s) URL and nothing else. For places that only ever
// mean a web page — an app's open-url/download action, a web fallback built from a deep link.
export function isHttpUrl(url) {
  return typeof url === 'string' && /^https?:\/\/[^/\s]/i.test(url.trim());
}
